// extracted by mini-css-extract-plugin
export default {"style-configurations__wrapper":"_6l5BwixW+7GE7q4Lg+Iwew==","style-configurations":"PUcbkUmRdGAX8UsUytSXQw=="};